// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TaKok","collageBody":"styles_collageBody__lF36m","logoWrapper":"styles_logoWrapper__M-LUC","collage":"styles_collage__uOxg+"};